export * from './use-fetch-merchant-general-block-detail'
